import { render, staticRenderFns } from "./PersonaImportPage.vue?vue&type=template&id=f272485e&scoped=true"
import script from "./PersonaImportPage.vue?vue&type=script&lang=js"
export * from "./PersonaImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272485e",
  null
  
)

export default component.exports